<template>
  <div class="worker-form">
    <div
      class="collapse-box"
      :style="
        `width: calc(100% - ${
          visibleHistory ? historyWidth : 0
        }px);height: 100%`
      "
    >
      <b-tabs v-model="currentTab" pills>
        <b-overlay :show="loading" rounded="sm" style="height: 100%">
          <template v-if="!loading">
            <!-- v-if="tab['tab'] !== 'teams'" -->
            <b-tab
              v-for="tab in tabs"
              :key="tab['tab']"
              :title="i18n(`form.tab.${tab.tab}`)"
              :active="activeTab === tab['tab']"
            >
              <!-- style="height: 100%;overflow-y: auto;" -->
              <div class="worker-form-body">
                <component
                  :is="tab['tab']"
                  :detail-type="detailType"
                  :data="data[tab.field]"
                  :employment="data.employmentVO"
                  :base-info="data.infoVO"
                  :team-list="data.teamList"
                  :refresh-change="refreshChange"
                  :current-id="currentId"
                  @submit="submitCallBack"
                />
                <!-- :data="data[tab.field]" -->
              </div>
            </b-tab>
          </template>
        </b-overlay>
      </b-tabs>
      <b-button
        v-if="tabs[currentTab] && tabs[currentTab].visibleHistory"
        variant="primary"
        class="btn-icon worker-form-historyBtn"
        @click="visibleHistory = !visibleHistory"
      >
        <feather-icon icon="ClockIcon" />
      </b-button>
      <div v-else class="worker-form-historyBtn user-info">
        <template v-if="data.infoVO">
          <div>
            <p class="user-info__name text-primary">
              {{ data.infoVO.name }}
            </p>
            <p class="user-info__code">
              {{ data.infoVO.employmentCode }}
            </p>
          </div>
          <div class="ml-1">
            <b-avatar
              :src="data.infoVO.photoType ? data.infoVO.dataphotoType : ''"
            />
          </div>
        </template>
      </div>
      <div
        class="collapse-box-right"
        :style="`right: -${historyWidth}px; width:${historyWidth}px`"
      >
        <c-history :visible="visibleHistory" />
      </div>
    </div>
  </div>
</template>

<script>
import { BTab, BTabs, BButton, BOverlay, BAvatar } from 'bootstrap-vue'
import WORKER from '@/api/worker/index'
import Personal from './tabPlane/Personal.vue'
import Employment from './tabPlane/Employment.vue'
import Certification from './tabPlane/Certification.vue'
import Salary from './tabPlane/Salary.vue'
import Teams from './tabPlane/Teams.vue'
import Others from './tabPlane/Others.vue'
import Projects from './tabPlane/Projects.vue'
import CHistory from './history/index.vue'
import TeamRecord from './tabPlane/TeamRecord.vue'

export default {
  name: 'WorkerForm',
  components: {
    BTab,
    BTabs,
    Personal,
    Employment,
    Certification,
    Salary,
    Others,
    Projects,
    Teams,
    BButton,
    CHistory,
    BOverlay,
    BAvatar,
    TeamRecord,
  },
  props: {
    currentId: {
      type: String,
      default: '',
    },
    detailType: {
      type: String,
      default: 'view',
    },
  },
  data() {
    return {
      data: {},
      currentTab: 0,
      activeTab: 'personal',
      historyWidth: 300,
      visibleHistory: false,
      loading: true,
    }
  },

  computed: {
    tabs() {
      const cols = [
        {
          tab: 'personal',
          field: 'infoVO',
          // visibleHistory: true,
        },
        {
          tab: 'employment',
          field: 'employmentVO',
          // visibleHistory: true,
        },
        {
          tab: 'certification',
          field: 'infoCertVOS',
        },
        {
          tab: 'salary',
          field: 'infoSalaryVOS',
        },
        {
          tab: 'others',
          field: 'infoEquipmentVOS',
        },
        {
          tab: 'projects',
          field: 'projectVOS',
        },
        {
          tab: 'teams',
          field: 'teams',
          hidden: this.data.employmentVO.isSupervisor === 0,
        },
        {
          tab: 'teamRecord',
          field: 'teamRecord',
        },
      ]
      const colss = cols.filter((el) => !el.hidden)

      // const colss = cols.filter(el => el.tab === 'teams' && this.data.employmentVO.isSupervisor)
      return colss
    },
  },
  mounted() {
    if (this.currentId) {
      this.onload(this.currentId)
    }
  },
  created() {},
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_worker.${param}`)
    },
    async onload(id, loading = true) {
      this.loading = loading
      const res = await WORKER.getWorkBaseDetail({ workerID: id })
      this.data = res.data.data
      this.loading = false
    },
    submitCallBack(tabName) {
      this.activeTab = tabName
      this.onload(this.currentId)
    },
    async refreshChange(done) {
      await this.onload(this.currentId, false)
      done()
    },
  },
}
</script>

<style lang="scss">
.worker-form {
  padding: 10px;
  overflow: hidden;
  height: 100%;
  .nav {
    height: 40px;
    flex-wrap: nowrap;
    width: calc(100% - 265px);
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }
  .tabs {
    height: 100%;
    .tab-content {
      overflow: auto;
      height: calc(100% - 60px);
      .tab-pane {
        height: 100%;
      }
    }
  }
  &-historyBtn {
    position: absolute;
    top: 0;
    right: 0;
  }
  &-body {
    display: block;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .collapse-box {
    transition: width 0.3s;
    position: relative;
    &-right {
      position: absolute;
      height: 100%;
      top: 0;
    }
  }
}

.user-info {
  background: #eee;
  border-radius: 3px;
  padding: 5px 10px;
  text-align: right;
  display: flex;
  align-items: center;
  p {
    margin: 0;
    padding: 0;
  }
  &__name {
    font-size: 16px;
  }
  &__code {
    color: #aaa;
    font-size: 12px;
  }
}
</style>
